<template>
  <div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledEfectivo" class="form-check-input"
             type="checkbox"
             value="efectivo" id="efectivo">
      <label class="form-check-label" for="efectivo">Efectivo</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledDebito" class="form-check-input"
             type="checkbox"
             value="debito" id="debito">
      <label class="form-check-label" for="debito">Tarjeta Débito</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledCredito" class="form-check-input"
             type="checkbox"
             value="credito" id="credito">
      <label class="form-check-label" for="credito">Tarjeta Crédito</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledCheque" class="form-check-input"
             type="checkbox"
             value="cheque" id="cheque">
      <label class="form-check-label" for="cheque">Cheque</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledDeposito" class="form-check-input"
             type="checkbox"
             value="deposito" id="deposito">
      <label class="form-check-label" for="deposito">Depósito</label>
    </div>
    <div class="form-check">
      <input @input="checkCreditoCliente" @change="check" v-model="forma_pago" :disabled="disabledCCliente"
             class="form-check-input"
             type="checkbox"
             value="credito_cliente" id="credito_cliente">
      <label class="form-check-label" for="credito_cliente">Crédito Cliente</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledNotaCredito" class="form-check-input"
             type="checkbox"
             value="nota_credito" id="nota_credito">
      <label class="form-check-label" for="nota_credito">Nota de Crédito</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledAbono" class="form-check-input"
             type="checkbox"
             value="abono" id="abono">
      <label class="form-check-label" for="abono">Abono</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="disabledWebpay" class="form-check-input"
             type="checkbox"
             value="webpay" id="webpay">
      <label class="form-check-label" for="webpay">WebPay</label>
    </div>
    <div class="form-check">
      <input @change="check" v-model="forma_pago" :disabled="false" class="form-check-input"
             type="checkbox"
             value="saldo_favor" id="saldo_favor">
      <label class="form-check-label" for="saldo_favor">Saldo Favor</label>
    </div>
  </div>

</template>

<script>

  export default {
    name: "formaPago",
    props: [
      'disabledEfectivo',
      'disabledDebito',
      'disabledCredito',
      'disabledCheque',
      'disabledCCliente',
      'disabledDeposito',
      'disabledNotaCredito',
      'disabledAbono',
      'disabledWebpay',
      'formasPago'
    ],
    created() {
      this.forma_pago = this.formasPago || []
    },
    data() {
      return {
        forma_pago: [],
      }
    },
    methods: {
      check() {
        this.$emit('check', {
          forma_pago: [...this.forma_pago],
        })
      },
      checkCreditoCliente(e) {
        this.$emit('creditoCliente', e.target.checked)
        if (e.target.checked)
          this.forma_pago = []
      }
    }
  }
</script>

<style scoped lang="scss">
  .form-check {
    margin-bottom: 20px;
    margin-left: 10px;

    input {
      cursor: pointer;
      height: 20px;
      width: 20px;
    }

    label {
      font-size: 18px;
      margin-left: 10px;
      font-weight: bold;
    }
  }
</style>
